import Link from 'next/link';

import s from './ClassicButton.module.css';

type TProps = {
  url?: string;
  children: React.ReactNode;
};

export const ClassicButton = ({ url = '', children }: TProps) => (
  <Link href={url} className={s.button}>
    {children}
  </Link>
);
